import { City } from './entities';


export const COLOR = {
  jungleGreen: '#27ab7d',
  shamrock: '#39d18a',
};

export const MADAD_CARD_WIDTH = {
  large: 312,
  default: 264,
};

export const CITIES: City[] = [
  {
    name: 'תל אביב',
    docIds: [ 'תל-אביב-יפו-ישראל' ],
    neighborhoods: [
      {
        docId: 'שכונה-לב-תל-אביב-תל-אביב-יפו-ישראל',
        name: 'לב תל אביב',
      },
      {
        docId: 'שכונה-נוה-אביבים-תל-אביב-יפו-ישראל',
        name: 'נוה אביבים',
      },
      {
        docId: 'שכונה-רמת-אביב-ג-תל-אביב-יפו-ישראל',
        name: 'רמת אביב ג',
      },
      {
        docId: 'שכונה-הצפון-הישן-החלק-הצפוני-תל-אביב-יפו-ישראל',
        name: 'הצפון הישן החלק הצפוני',
      },
      {
        docId: 'שכונה-כפר-שלם-תל-אביב-יפו-ישראל',
        name: 'כפר שלם',
      },
      {
        docId: 'שכונה-נוה-שאנן-תל-אביב-יפו-ישראל',
        name: 'נוה שאנן',
      },
      {
        docId: 'שכונה-שוק-הפשפשים-וצפון-יפו-תל-אביב-יפו-ישראל',
        name: 'שוק הפשפשים וצפון יפו',
      },
      {
        docId: 'שכונה-אזורי-חן-תל-אביב-יפו-ישראל',
        name: 'אזורי חן',
      },
      {
        docId: 'שכונה-הצפון-החדש-החלק-הדרומי-תל-אביב-יפו-ישראל',
        name: 'הצפון החדש החלק הדרומי',
      },
      {
        docId: 'שכונה-הצפון-הישן-החלק-המרכזי-תל-אביב-יפו-ישראל',
        name: 'הצפון הישן החלק המרכזי',
      },
      { name: 'ביצרון', docId: 'שכונה-ביצרון-תל-אביב-יפו-ישראל' },
      { name: 'גני צהלה', docId: 'שכונה-גני-צהלה-תל-אביב-יפו-ישראל' },
      { name: 'דקר', docId: 'שכונה-דקר-תל-אביב-יפו-ישראל' },
      { name: 'הדר יוסף', docId: 'שכונה-הדר-יוסף-תל-אביב-יפו-ישראל' },
      { name: 'המשתלה', docId: 'שכונה-המשתלה-תל-אביב-יפו-ישראל' },
      { name: 'הצפון החדש החלק הצפוני', docId: 'שכונה-הצפון-החדש-החלק-הצפוני-תל-אביב-יפו-ישראל' },
      { name: 'הצפון החדש סביבת כיכר המדינה', docId: 'שכונה-הצפון-החדש-סביבת-כיכר-המדינה-תל-אביב-יפו-ישראל' },
      { name: 'הצפון הישן החלק הדרום מזרחי', docId: 'שכונה-הצפון-הישן-החלק-הדרום-מזרחי-תל-אביב-יפו-ישראל' },
      { name: 'הצפון הישן החלק הדרום מערבי', docId: 'שכונה-הצפון-הישן-החלק-הדרום-מערבי-תל-אביב-יפו-ישראל' },
      { name: 'התקווה', docId: 'שכונה-התקווה-תל-אביב-יפו-ישראל' },
      { name: 'יפו ג', docId: 'שכונה-יפו-ג-תל-אביב-יפו-ישראל' },
      { name: 'יפו ד', docId: 'שכונה-יפו-ד-תל-אביב-יפו-ישראל' },
      { name: 'כרם התימנים', docId: 'שכונה-כרם-התימנים-תל-אביב-יפו-ישראל' },
      { name: 'מונטיפיורי', docId: 'שכונה-מונטיפיורי-תל-אביב-יפו-ישראל' },
      { name: 'מע״ר צפוני', docId: 'שכונה-מער-צפוני-תל-אביב-יפו-ישראל' },
      { name: 'מרכז יפו', docId: 'שכונה-מרכז-יפו-תל-אביב-יפו-ישראל' },
      { name: 'נאות אפקה ב', docId: 'שכונה-נאות-אפקה-ב-תל-אביב-יפו-ישראל' },
      { name: 'נוה גולן', docId: 'שכונה-נוה-גולן-תל-אביב-יפו-ישראל' },
      { name: 'נוה שרת', docId: 'שכונה-נוה-שרת-תל-אביב-יפו-ישראל' },
      { name: 'נווה עופר', docId: 'שכונה-נווה-עופר-תל-אביב-יפו-ישראל' },
      { name: 'עג\'מי', docId: 'שכונה-עגמי-תל-אביב-יפו-ישראל' },
      { name: 'פארק צמרת', docId: 'שכונה-פארק-צמרת-תל-אביב-יפו-ישראל' },
      { name: 'פלורנטין', docId: 'שכונה-פלורנטין-תל-אביב-יפו-ישראל' },
      { name: 'צהלון ושיכוני חסכון', docId: 'שכונה-צהלון-ושיכוני-חסכון-תל-אביב-יפו-ישראל' },
      { name: 'קרית שלום', docId: 'שכונה-קרית-שלום-תל-אביב-יפו-ישראל' },
      { name: 'רביבים', docId: 'שכונה-רביבים-תל-אביב-יפו-ישראל' },
      { name: 'רמות צהלה', docId: 'שכונה-רמות-צהלה-תל-אביב-יפו-ישראל' },
      { name: 'רמת אביב החדשה', docId: 'שכונה-רמת-אביב-החדשה-תל-אביב-יפו-ישראל' },
      { name: 'רמת אביב', docId: 'שכונה-רמת-אביב-תל-אביב-יפו-ישראל' },
      { name: 'שיכון בבלי', docId: 'שכונה-שיכון-בבלי-תל-אביב-יפו-ישראל' },
      { name: 'שיכון עממי ג\'', docId: 'שכונה-שיכון-עממי-ג-תל-אביב-יפו-ישראל' },
      { name: 'שרונה', docId: 'שכונה-שרונה-תל-אביב-יפו-ישראל' },
      { name: 'תוכנית ל', docId: 'שכונה-תוכנית-ל-תל-אביב-יפו-ישראל' },
      { name: 'תל ברוך צפון', docId: 'שכונה-תל-ברוך-צפון-תל-אביב-יפו-ישראל' },
      { name: 'תל ברוך', docId: 'שכונה-תל-ברוך-תל-אביב-יפו-ישראל' },
      { name: 'תל חיים', docId: 'שכונה-תל-חיים-תל-אביב-יפו-ישראל' },
    ],
  },
  {
    name: 'רמת גן',
    docIds: [ 'רמת-גן-ישראל' ],
    neighborhoods: [
      {
        docId: 'שכונה-מרכז-העיר-ג-רמת-גן-ישראל',
        name: `מרכז העיר ג'`,
      },
      {
        docId: 'שכונה-יד-לבנים-רמת-גן-ישראל',
        name: 'יד לבנים',
      },
      {
        docId: 'שכונה-מתחם-נגבה-רמת-גן-ישראל',
        name: 'מתחם נגבה',
      },
      {
        docId: 'שכונה-החרוזים-רמת-גן-ישראל',
        name: 'החרוזים',
      },
      { name: 'המשולש הגדול - קרית קריניצי החדשה', docId: 'שכונה-המשולש-הגדול---קרית-קריניצי-החדשה-רמת-גן-ישראל' },
      { name: 'מרום נווה', docId: 'שכונה-מרום-נווה-רמת-גן-ישראל' },
      { name: 'מרכז העיר א\'', docId: 'שכונה-מרכז-העיר-א-רמת-גן-ישראל' },
      { name: 'מרכז העיר ב\'', docId: 'שכונה-מרכז-העיר-ב-רמת-גן-ישראל' },
      { name: 'נווה יהושע', docId: 'שכונה-נווה-יהושע-רמת-גן-ישראל' },
      { name: 'נחלת גנים', docId: 'שכונה-נחלת-גנים-רמת-גן-ישראל' },
      { name: 'רמת יצחק', docId: 'שכונה-רמת-יצחק-רמת-גן-ישראל' },
      { name: 'רמת עמידר', docId: 'שכונה-רמת-עמידר-רמת-גן-ישראל' },
      { name: 'שיכון מזרחי', docId: 'שכונה-שיכון-מזרחי-רמת-גן-ישראל' },
      { name: 'שכונת הלל', docId: 'שכונה-שכונת-הלל-רמת-גן-ישראל' },
      { name: 'שכונת הראשונים', docId: 'שכונה-שכונת-הראשונים-רמת-גן-ישראל' },
      { name: 'תל יהודה', docId: 'שכונה-תל-יהודה-רמת-גן-ישראל' },
    ],
  },
  {
    name: 'בת ים - חולון',
    docIds: [
      'בת-ים-ישראל',
      'חולון-ישראל',
    ],
    neighborhoods: [
      {
        name: 'מרכז העיר, בת ים',
        docId: 'שכונה-מרכז-העיר-בת-ים-ישראל',
      },
      {
        name: 'דרום מערב, בת ים',
        docId: 'שכונה-דרום-מערב-בת-ים-ישראל',
      },
      {
        name: 'קריית שרת, חולון',
        docId: 'שכונה-קריית-שרת-חולון-ישראל',
      },
      {
        name: 'נאות רחל, חולון',
        docId: 'שכונה-נאות-רחל-חולון-ישראל',
      },
      {
        name: 'אגרובנק, חולון',
        docId: 'שכונה-אגרובנק-חולון-ישראל',
      },
      { name: 'ג\'סי כהן, חולון', docId: 'שכונה-גסי-כהן-חולון-ישראל' },
      { name: 'נאות שושנים, חולון', docId: 'שכונה-נאות-שושנים-חולון-ישראל' },
      { name: 'עמידר/ניצנה, בת ים', docId: 'שכונה-עמידרניצנה-בת-ים-ישראל' },
      { name: 'צפון מערב, בת ים', docId: 'שכונה-צפון-מערב-בת-ים-ישראל' },
      { name: 'קרית בן גוריון, חולון', docId: 'שכונה-קרית-בן-גוריון-חולון-ישראל' },
      { name: 'רמת הנשיא, בת ים', docId: 'שכונה-רמת-הנשיא-בת-ים-ישראל' },
      { name: 'רסקו א, חולון', docId: 'שכונה-רסקו-א-חולון-ישראל' },
      { name: 'רסקו ב, חולון', docId: 'שכונה-רסקו-ב-חולון-ישראל' },
      { name: 'שיכון ותיקים, בת ים', docId: 'שכונה-שיכון-ותיקים-בת-ים-ישראל' },
      { name: 'תל גיבורים, חולון', docId: 'שכונה-תל-גיבורים-חולון-ישראל' },
    ],
  },
  {
    name: 'ראשון לציון',
    docIds: [ 'ראשון-לציון-ישראל' ],
    neighborhoods: [
      { name: 'אברמוביץ', docId: 'שכונה-אברמוביץ-ראשון-לציון-ישראל' },
      { name: 'כצנלסון', docId: 'שכונה-כצנלסון-ראשון-לציון-ישראל' },
      { name: 'מישור הנוף', docId: 'שכונה-מישור-הנוף-ראשון-לציון-ישראל' },
      { name: 'נאות אשלים', docId: 'שכונה-נאות-אשלים-ראשון-לציון-ישראל' },
      { name: 'נאות שקמה', docId: 'שכונה-נאות-שקמה-ראשון-לציון-ישראל' },
      { name: 'נווה חוף', docId: 'שכונה-נווה-חוף-ראשון-לציון-ישראל' },
      { name: 'נווה ים', docId: 'שכונה-נווה-ים-ראשון-לציון-ישראל' },
      { name: 'נחלת יהודה', docId: 'שכונה-נחלת-יהודה-ראשון-לציון-ישראל' },
      { name: 'קרית גנים', docId: 'שכונה-קרית-גנים-ראשון-לציון-ישראל' },
      { name: 'קרית הלאום', docId: 'שכונה-קרית-הלאום-ראשון-לציון-ישראל' },
      { name: 'רביבים', docId: 'שכונה-רביבים-ראשון-לציון-ישראל' },
      { name: 'רמב"ם', docId: 'שכונה-רמבם-ראשון-לציון-ישראל' },
      { name: 'רמז', docId: 'שכונה-רמז-ראשון-לציון-ישראל' },
      { name: 'הראשונים', docId: 'שכונה-הראשונים-ראשון-לציון-ישראל' },
    ],
  },
  {
    name: 'רחובות',
    docIds: [ 'רחובות-ישראל' ],
    neighborhoods: [
      {
        docId: 'שכונה-מרכז-העיר-רחובות-ישראל',
        name: 'מרכז-העיר',
      },
      {
        docId: 'שכונה-צפון-מזרח-העיר-רחובות-ישראל',
        name: 'צפון מזרח העיר',
      },
      {
        docId: 'שכונה-צפון-מערב-העיר-רחובות-ישראל',
        name: 'צפון מערב העיר',
      },
      { name: 'אזורי ויצמן', docId: 'שכונה-אזורי-ויצמן-רחובות-ישראל' },
      { name: 'אחוזת הנשיא', docId: 'שכונה-אחוזת-הנשיא-רחובות-ישראל' },
      { name: 'נווה יהודה', docId: 'שכונה-נווה-יהודה-רחובות-ישראל' },
      { name: 'צפון מערב העיר', docId: 'שכונה-צפון-מערב-העיר-רחובות-ישראל' },
      { name: 'רחובות המדע', docId: 'שכונה-רחובות-המדע-רחובות-ישראל' },
      { name: 'אבן גבירול', docId: 'שכונה-אבן-גבירול-רחובות-ישראל' },
    ],
  },
  {
    name: 'ירושלים',
    docIds: [ 'ירושלים-ישראל' ],
    neighborhoods: [
      {
        docId: 'שכונה-קרית-היובל-ירושלים-ישראל',
        name: 'קרית היובל',
      },
      {
        docId: 'שכונה-פסגת-זאב-ירושלים-ישראל',
        name: 'פסגת זאב',
      },
      {
        docId: 'שכונה-גילה-ירושלים-ישראל',
        name: 'גילה',
      },
      {
        docId: 'שכונה-הר-חומה-ירושלים-ישראל',
        name: 'הר חומה',
      },
      {
        docId: 'שכונה-בית-הכרם-ירושלים-ישראל',
        name: 'בית הכרם',
      },
      {
        docId: 'שכונה-נחלאות-ירושלים-ישראל',
        name: 'נחלאות',
      },
      {
        docId: 'שכונה-עיר-גנים-ב-ג-ירושלים-ישראל',
        name: `עיר גנים ב', ג'`,
      },
      { name: 'ארמון הנציב', docId: 'שכונה-ארמון-הנציב-ירושלים-ישראל' },
      { name: 'ארנונה (תלפיות)', docId: 'שכונה-ארנונה-תלפיות-ירושלים-ישראל' },
      { name: 'גבעת משואה', docId: 'שכונה-גבעת-משואה-ירושלים-ישראל' },
      { name: 'הגבעה הצרפתית', docId: 'שכונה-הגבעה-הצרפתית-ירושלים-ישראל' },
      { name: 'המושבה הגרמנית', docId: 'שכונה-המושבה-הגרמנית-ירושלים-ישראל' },
      { name: 'הר נוף', docId: 'שכונה-הר-נוף-ירושלים-ישראל' },
      { name: 'טלביה', docId: 'שכונה-טלביה-ירושלים-ישראל' },
      { name: 'מלחה', docId: 'שכונה-מלחה-ירושלים-ישראל' },
      { name: 'מרכז העיר', docId: 'שכונה-מרכז-העיר-ירושלים-ישראל' },
      { name: 'קטמון א-ו', docId: 'שכונה-קטמון-א-ו-ירושלים-ישראל' },
      { name: 'קטמון הישנה', docId: 'שכונה-קטמון-הישנה-ירושלים-ישראל' },
      { name: 'קרית הלאום', docId: 'שכונה-קרית-הלאום-ירושלים-ישראל' },
      { name: 'קרית מנחם', docId: 'שכונה-קרית-מנחם-ירושלים-ישראל' },
      { name: 'קרית משה', docId: 'שכונה-קרית-משה-ירושלים-ישראל' },
      { name: 'רחביה', docId: 'שכונה-רחביה-ירושלים-ישראל' },
      { name: 'רמות', docId: 'שכונה-רמות-ירושלים-ישראל' },
      { name: 'רמת אשכול', docId: 'שכונה-רמת-אשכול-ירושלים-ישראל' },
      { name: 'רמת בית הכרם', docId: 'שכונה-רמת-בית-הכרם-ירושלים-ישראל' },
      { name: 'רמת דניה', docId: 'שכונה-רמת-דניה-ירושלים-ישראל' },
      { name: 'רמת שרת', docId: 'שכונה-רמת-שרת-ירושלים-ישראל' },
      { name: 'רסקו (גבעת הורדים)', docId: 'שכונה-רסקו-גבעת-הורדים-ירושלים-ישראל' },
    ],
  },
  {
    name: 'מודיעין מכבים רעות',
    docIds: [ 'מודיעין-מכבים-רעות-ישראל' ],
    neighborhoods: [
      { name: 'אבני חן (קייזר)', docId: 'שכונה-אבני-חן-קייזר-מודיעין-מכבים-רעות-ישראל' },
      { name: 'הכרמים (ציפור)', docId: 'שכונה-הכרמים-ציפור-מודיעין-מכבים-רעות-ישראל' },
      { name: 'המגינים (השמשוני דרום)', docId: 'שכונה-המגינים-השמשוני-דרום-מודיעין-מכבים-רעות-ישראל' },
      { name: 'הנביאים (השמשוני צפון)', docId: 'שכונה-הנביאים-השמשוני-צפון-מודיעין-מכבים-רעות-ישראל' },
      { name: 'הנחלים (ספדיה)', docId: 'שכונה-הנחלים-ספדיה-מודיעין-מכבים-רעות-ישראל' },
      { name: 'השבטים (בוכמן צפון)', docId: 'שכונה-השבטים-בוכמן-צפון-מודיעין-מכבים-רעות-ישראל' },
      { name: 'הפרחים (מירומי)', docId: 'שכונה-הפרחים-מירומי-מודיעין-מכבים-רעות-ישראל' },
      { name: 'מוריה (בוכמן דרום)', docId: 'שכונה-מוריה-בוכמן-דרום-מודיעין-מכבים-רעות-ישראל' },
      { name: 'משואה (גבעת C)', docId: 'שכונה-משואה-גבעת-c-מודיעין-מכבים-רעות-ישראל' },
      { name: 'נופים', docId: 'שכונה-נופים-מודיעין-מכבים-רעות-ישראל' },
      { name: 'רעות', docId: 'שכונה-רעות-מודיעין-מכבים-רעות-ישראל' },
    ],
  },
  {
    name: 'חיפה',
    docIds: [ 'חיפה-ישראל' ],
    neighborhoods: [
      {
        docId: 'שכונה-נוה-שאנן-חיפה-ישראל',
        name: 'נוה שאנן',
      },
      {
        docId: 'שכונה-כרמל-מערבי-חיפה-ישראל',
        name: 'כרמל מערבי',
      },
      {
        docId: 'שכונה-יזרעאליה-חיפה-ישראל',
        name: 'יזרעאליה',
      },
      {
        docId: 'שכונה-רמות-רמז-חיפה-ישראל',
        name: 'רמות רמז',
      },
      {
        docId: 'שכונה-קרית-אליעזר-חיפה-ישראל',
        name: 'קרית אליעזר',
      },
      {
        docId: 'שכונה-הדר-הכרמל-חיפה-ישראל',
        name: 'הדר הכרמל',
      },
      {
        docId: 'שכונה-קרית-שפרינצק-חיפה-ישראל',
        name: 'קרית שפרינצק',
      },
      {
        docId: 'שכונה-אחוזה-חיפה-ישראל',
        name: 'אחוזה',
      },
      {
        docId: 'שכונה-כרמליה-חיפה-ישראל',
        name: 'כרמליה',
      },
      {
        docId: 'שכונה-תל-עמל-חיפה-ישראל',
        name: 'תל עמל',
      },
      {
        docId: 'שכונה-בת-גלים-חיפה-ישראל',
        name: 'בת גלים',
      },
      {
        docId: 'שכונה-נוה-יוסף-חיפה-ישראל',
        name: 'נוה יוסף',
      },
      {
        docId: 'שכונה-נאות-פרס-חיפה-ישראל',
        name: 'נאות פרס',
      },
      { name: 'גבעת דאונס', docId: 'שכונה-גבעת-דאונס-חיפה-ישראל' },
      { name: 'דניה', docId: 'שכונה-דניה-חיפה-ישראל' },
      { name: 'הדר עליון', docId: 'שכונה-הדר-עליון-חיפה-ישראל' },
      { name: 'המושבה הגרמנית', docId: 'שכונה-המושבה-הגרמנית-חיפה-ישראל' },
      { name: 'ורדיה', docId: 'שכונה-ורדיה-חיפה-ישראל' },
      { name: 'כרמל ותיק', docId: 'שכונה-כרמל-ותיק-חיפה-ישראל' },
      { name: 'כרמל צפוני', docId: 'שכונה-כרמל-צפוני-חיפה-ישראל' },
      { name: 'כרמל צרפתי', docId: 'שכונה-כרמל-צרפתי-חיפה-ישראל' },
      { name: 'מרכז הכרמל', docId: 'שכונה-מרכז-הכרמל-חיפה-ישראל' },
      { name: 'נוה פז', docId: 'שכונה-נוה-פז-חיפה-ישראל' },
      { name: 'סביוני דניה', docId: 'שכונה-סביוני-דניה-חיפה-ישראל' },
      { name: 'עבאס', docId: 'שכונה-עבאס-חיפה-ישראל' },
      { name: 'קריית שמואל', docId: 'שכונה-קריית-שמואל-חיפה-ישראל' },
      { name: 'קרית אליהו', docId: 'שכונה-קרית-אליהו-חיפה-ישראל' },
      { name: 'קרית שפרינצק', docId: 'שכונה-קרית-שפרינצק-חיפה-ישראל' },
      { name: 'רוממה החדשה', docId: 'שכונה-רוממה-החדשה-חיפה-ישראל' },
      { name: 'רמת אלון', docId: 'שכונה-רמת-אלון-חיפה-ישראל' },
      { name: 'רמת אלמוגי', docId: 'שכונה-רמת-אלמוגי-חיפה-ישראל' },
      { name: 'רמת אשכול', docId: 'שכונה-רמת-אשכול-חיפה-ישראל' },
      { name: 'רמת בגין', docId: 'שכונה-רמת-בגין-חיפה-ישראל' },
      { name: 'רמת גולדה', docId: 'שכונה-רמת-גולדה-חיפה-ישראל' },
      { name: 'רמת הדר', docId: 'שכונה-רמת-הדר-חיפה-ישראל' },
      { name: 'רמת הנשיא', docId: 'שכונה-רמת-הנשיא-חיפה-ישראל' },
      { name: 'רמת התשבי', docId: 'שכונה-רמת-התשבי-חיפה-ישראל' },
      { name: 'שמבור', docId: 'שכונה-שמבור-חיפה-ישראל' },
      { name: 'שער העליה', docId: 'שכונה-שער-העליה-חיפה-ישראל' },
    ],
  },
  {
    name: 'הקריות',
    docIds: [
      'קרית-ביאליק-ישראל',
      'קרית-חיים-מזרחית-ישראל',
      'קרית-ים-ישראל',
      'קרית-חיים-מערבית-ישראל',
      'קרית-מוצקין-ישראל',
      'קרית-אתא-ישראל',
    ],
    neighborhoods: [
      {
        docId: 'שכונה-מרכז-העיר-קרית-ביאליק-ישראל',
        name: 'מרכז העיר, קרית ביאליק',
      },
      {
        docId: 'שכונה-צור-שלום-קרית-ביאליק-ישראל',
        name: 'צור שלום, קרית ביאליק',
      },
      {
        docId: 'שכונה-מרכז-העיר-קרית-אתא-ישראל',
        name: 'מרכז העיר, קרית אתא',
      },
      {
        docId: 'שכונה-מוצקין-הותיקה-קרית-מוצקין-ישראל',
        name: 'מוצקין הותיקה, קרית מוצקין',
      },
      {
        docId: 'שכונה-לב-העיר-קרית-מוצקין-ישראל',
        name: 'לב העיר, קרית מוצקין',
      },
      {
        docId: 'שכונה-סביוני-ים-קרית-ים-ישראל',
        name: 'סביוני ים, קרית ים',
      },
      {
        docId: 'שכונה-קרית-חיים-מזרחית-חיפה-ישראל',
        name: 'קרית חיים מזרחית, קריות',
      },
      {
        docId: 'שכונה-קרית-חיים-מערבית-חיפה-ישראל',
        name: 'קרית חיים מערבית, קריות',
      },
      { name: 'אברמסקי, קרית אתא', docId: 'שכונה-אברמסקי-קרית-אתא-ישראל' },
      { name: 'אלמוגים, קרית ים', docId: 'שכונה-אלמוגים-קרית-ים-ישראל' },
      { name: 'אפק, קרית ביאליק', docId: 'שכונה-אפק-קרית-ביאליק-ישראל' },
      { name: 'גבעה א, קרית אתא', docId: 'שכונה-גבעה-א-קרית-אתא-ישראל' },
      { name: 'גבעת הרקפות, קרית אתא', docId: 'שכונה-גבעת-הרקפות-קרית-אתא-ישראל' },
      { name: 'גבעת הרקפות, קרית ביאליק', docId: 'שכונה-גבעת-הרקפות-קרית-ביאליק-ישראל' },
      { name: 'דרום, קרית ביאליק', docId: 'שכונה-דרום-קרית-ביאליק-ישראל' },
      { name: 'לב העיר, קרית מוצקין', docId: 'שכונה-לב-העיר-קרית-מוצקין-ישראל' },
      { name: 'נווה גנים ומוצקין הצעירה, קרית מוצקין', docId: 'שכונה-נווה-גנים-ומוצקין-הצעירה-קרית-מוצקין-ישראל' },
      { name: 'נווה חן, קרית אתא', docId: 'שכונה-נווה-חן-קרית-אתא-ישראל' },
      { name: 'פסגות ים, קרית ים', docId: 'שכונה-פסגות-ים-קרית-ים-ישראל' },
      { name: 'פרפר, קרית ביאליק', docId: 'שכונה-פרפר-קרית-ביאליק-ישראל' },
      { name: 'קרית בנימין, קרית אתא', docId: 'שכונה-קרית-בנימין-קרית-אתא-ישראל' },
      { name: 'קרית ים א, קרית ים', docId: 'שכונה-קרית-ים-א-קרית-ים-ישראל' },
      { name: 'קרית ים ב, קרית ים', docId: 'שכונה-קרית-ים-ב-קרית-ים-ישראל' },
    ],
  },
  {
    name: 'חדרה והסביבה',
    docIds: [
      'חדרה-ישראל',
      'פרדס-חנה-כרכור-ישראל',
    ],
    neighborhoods: [
      {
        name: 'מרכז העיר, חדרה',
        docId: 'שכונה-מרכז-העיר-חדרה-ישראל',
      },
      {
        name: 'בית אליעזר, חדרה',
        docId: 'שכונה-בית-אליעזר-חדרה-ישראל',
      },
      {
        name: 'שכונת הפארק, חדרה',
        docId: 'שכונה-שכונת-הפארק-חדרה-ישראל',
      },
      { name: 'אחוזת דניה, חדרה', docId: 'שכונה-אחוזת-דניה-חדרה-ישראל' },
      { name: 'בית"ר, חדרה', docId: 'שכונה-ביתר-חדרה-ישראל' },
      { name: 'גבעת אולגה א\' ו-ב\', חדרה', docId: 'שכונה-גבעת-אולגה-א-ו-ב-חדרה-ישראל' },
      { name: 'גבעת אולגה ג\' ו-ד\', חדרה', docId: 'שכונה-גבעת-אולגה-ג-ו-ד-חדרה-ישראל' },
      { name: 'גני אלון/הזיתים, חדרה', docId: 'שכונה-גני-אלוןהזיתים-חדרה-ישראל' },
      { name: 'האוצר, חדרה', docId: 'שכונה-האוצר-חדרה-ישראל' },
      { name: 'נאות הגולף, קיסריה', docId: 'שכונה-נאות-הגולף-קיסריה-ישראל' },
      { name: 'נוה גנים, פרדס חנה כרכור', docId: 'שכונה-נוה-גנים-פרדס-חנה-כרכור-ישראל' },
      { name: 'נוה פרדסים, פרדס חנה כרכור', docId: 'שכונה-נוה-פרדסים-פרדס-חנה-כרכור-ישראל' },
      { name: 'נווה הדרים, פרדס חנה כרכור', docId: 'שכונה-נווה-הדרים-פרדס-חנה-כרכור-ישראל' },
      { name: 'נווה חיים/ויצמן, חדרה', docId: 'שכונה-נווה-חייםויצמן-חדרה-ישראל' },
      { name: 'גני אלון/הזיתים, חדרה', docId: 'שכונה-גני-אלוןהזיתים-חדרה-ישראל' },
      { name: 'ניסן, חדרה', docId: 'שכונה-ניסן-חדרה-ישראל' },
      { name: 'עין הים, חדרה', docId: 'שכונה-עין-הים-חדרה-ישראל' },
      { name: 'קדמת ים, חדרה', docId: 'שכונה-קדמת-ים-חדרה-ישראל' },
      { name: 'רמב"ם, חדרה', docId: 'שכונה-רמבם-חדרה-ישראל' },
      { name: 'שמשון/שלמה/ביאליק, חדרה', docId: 'שכונה-שמשוןשלמהביאליק-חדרה-ישראל' },
    ],
  },
  {
    name: 'נתניה',
    docIds: [ 'נתניה-ישראל' ],
    neighborhoods: [
      {
        docId: 'שכונה-מרכז-העיר-דרום-נתניה-ישראל',
        name: 'מרכז העיר דרום',
      },
      {
        docId: 'שכונה-עיר-ימים-נתניה-ישראל',
        name: 'עיר ימים',
      },
      {
        docId: 'שכונה-מרכז-העיר-צפון-נתניה-ישראל',
        name: 'מרכז העיר צפון',
      },
      {
        docId: 'שכונה-רמת-פולג-נתניה-ישראל',
        name: 'רמת פולג',
      },
      {
        docId: 'שכונה-גבעת-האירוסים-נתניה-ישראל',
        name: 'גבעת האירוסים',
      },
      {
        docId: 'שכונה-קרית-נורדאו-נתניה-ישראל',
        name: 'קרית נורדאו',
      },
      { name: 'אגמים', docId: 'שכונה-אגמים-נתניה-ישראל' },
      { name: 'נאות גולדה', docId: 'שכונה-נאות-גולדה-נתניה-ישראל' },
      { name: 'נאות הרצל', docId: 'שכונה-נאות-הרצל-נתניה-ישראל' },
      { name: 'נאות שקד', docId: 'שכונה-נאות-שקד-נתניה-ישראל' },
      { name: 'קרית השרון', docId: 'שכונה-קרית-השרון-נתניה-ישראל' },
      { name: 'רצועת המלונות', docId: 'שכונה-רצועת-המלונות-נתניה-ישראל' },
    ],
  },
  {
    name: 'הרצליה',
    docIds: [ 'הרצליה-ישראל' ],
    neighborhoods: [
      {
        docId: 'שכונה-מרכז-הרצליה-ישראל',
        name: 'מרכז',
      },
      {
        docId: 'שכונה-הירוקה-המרכזית-הרצליה-ישראל',
        name: 'הירוקה המרכזית',
      },
      {
        docId: 'שכונה-הרצליה-הצעירה-הרצליה-ישראל',
        name: 'הרצליה הצעירה',
      },
      { name: 'הירוקה המזרחית', docId: 'שכונה-הירוקה-המזרחית-הרצליה-ישראל' },
      { name: 'הירוקה המערבית', docId: 'שכונה-הירוקה-המערבית-הרצליה-ישראל' },
      { name: 'הרצליה פיתוח', docId: 'שכונה-הרצליה-פיתוח-הרצליה-ישראל' },
      { name: 'יד התשעה', docId: 'שכונה-יד-התשעה-הרצליה-ישראל' },
      { name: 'נוה אמירים', docId: 'שכונה-נוה-אמירים-הרצליה-ישראל' },
    ],
  },
  {
    name: 'רעננה',
    docIds: [ 'רעננה-ישראל' ],
    neighborhoods: [
      {
        docId: 'שכונה-נווה-זמר-רעננה-ישראל',
        name: 'נווה זמר',
      },
      {
        docId: 'שכונה-קרית-דוד-רמז-רעננה-ישראל',
        name: 'קרית דוד רמז',
      },
      { name: '2005', docId: 'שכונה-2005-רעננה-ישראל' },
      { name: 'לב הפארק', docId: 'שכונה-לב-הפארק-רעננה-ישראל' },
      { name: 'מרכז דרום', docId: 'שכונה-מרכז-דרום-רעננה-ישראל' },
      { name: 'קרית ויצמן', docId: 'שכונה-קרית-ויצמן-רעננה-ישראל' },
      { name: 'קרית שרת', docId: 'שכונה-קרית-שרת-רעננה-ישראל' },
      { name: 'שיכון אשר', docId: 'שכונה-שיכון-אשר-רעננה-ישראל' },
    ],
  },
  {
    name: 'הוד השרון',
    docIds: [ 'הוד-השרון-ישראל' ],
    neighborhoods: [
      {
        docId: 'שכונה-רמתיים-הוד-השרון-ישראל',
        name: 'רמתיים',
      },
      {
        docId: 'שכונה-מגדיאל-הוד-השרון-ישראל',
        name: 'מגדיאל',
      },
      {
        docId: 'שכונה-מתחם-1200-הוד-השרון-ישראל',
        name: 'מתחם 1200',
      },
      { name: 'גני צבי', docId: 'שכונה-גני-צבי-הוד-השרון-ישראל' },
      { name: 'גרינפארק', docId: 'שכונה-גרינפארק-הוד-השרון-ישראל' },
      { name: 'הדר', docId: 'שכונה-הדר-הוד-השרון-ישראל' },
      { name: 'הפרחים', docId: 'שכונה-הפרחים-הוד-השרון-ישראל' },
      { name: 'מרכז העיר', docId: 'שכונה-מרכז-העיר-הוד-השרון-ישראל' },
      { name: 'מתחם 200', docId: 'שכונה-מתחם-200-הוד-השרון-ישראל' },
      { name: 'רמות מנחם', docId: 'שכונה-רמות-מנחם-הוד-השרון-ישראל' },
      { name: 'רסקו', docId: 'שכונה-רסקו-הוד-השרון-ישראל' },
    ],
  },
  {
    name: 'פתח תקווה',
    docIds: [ 'פתח-תקווה-ישראל' ],
    neighborhoods: [
      {
        docId: 'שכונה-המרכז-השקט-פתח-תקווה-ישראל',
        name: 'המרכז השקט',
      },
      {
        docId: 'שכונה-מרכז-העיר-פתח-תקווה-ישראל',
        name: 'מרכז העיר',
      },
      {
        docId: 'שכונה-רמת-ורבר-פתח-תקווה-ישראל',
        name: 'רמת ורבר',
      },
      {
        docId: 'שכונה-כפר-גנים-ג-פתח-תקווה-ישראל',
        name: 'כפר גנים ג',
      },
      {
        docId: 'שכונה-הדר-גנים-פתח-תקווה-ישראל',
        name: 'הדר גנים',
      },
      {
        docId: 'שכונה-עין-גנים-פתח-תקווה-ישראל',
        name: 'עין גנים',
      },
      {
        docId: 'שכונה-נווה-גן-פתח-תקווה-ישראל',
        name: 'נווה גן',
      },
      { name: 'אחדות', docId: 'שכונה-אחדות-פתח-תקווה-ישראל' },
      { name: 'אם המושבות הותיקה', docId: 'שכונה-אם-המושבות-הותיקה-פתח-תקווה-ישראל' },
      { name: 'אם המושבות החדשה', docId: 'שכונה-אם-המושבות-החדשה-פתח-תקווה-ישראל' },
      { name: 'בר יהודה', docId: 'שכונה-בר-יהודה-פתח-תקווה-ישראל' },
      { name: 'יוספטל', docId: 'שכונה-יוספטל-פתח-תקווה-ישראל' },
      { name: 'כפר גנים א', docId: 'שכונה-כפר-גנים-א-פתח-תקווה-ישראל' },
      { name: 'כפר גנים ב', docId: 'שכונה-כפר-גנים-ב-פתח-תקווה-ישראל' },
      { name: 'מחנה יהודה', docId: 'שכונה-מחנה-יהודה-פתח-תקווה-ישראל' },
      { name: 'נווה גן', docId: 'שכונה-נווה-גן-פתח-תקווה-ישראל' },
      { name: 'נווה דקלים', docId: 'שכונה-נווה-דקלים-פתח-תקווה-ישראל' },
      { name: 'עמישב', docId: 'שכונה-עמישב-פתח-תקווה-ישראל' },
      { name: 'קריית חזני', docId: 'שכונה-קריית-חזני-פתח-תקווה-ישראל' },
      { name: 'קרית אליעזר פרי', docId: 'שכונה-קרית-אליעזר-פרי-פתח-תקווה-ישראל' },
      { name: 'קרית הרב סלומון', docId: 'שכונה-קרית-הרב-סלומון-פתח-תקווה-ישראל' },
      { name: 'שיכון מפ"ם', docId: 'שכונה-שיכון-מפם-פתח-תקווה-ישראל' },
      { name: 'שיפר', docId: 'שכונה-שיפר-פתח-תקווה-ישראל' },
    ],
  },
];
